export const SEEDANCE_25_MODELS = new Set([
  'bytedance/seedance-2.5/text-to-video',
  'bytedance/seedance-2.5/image-to-video',
  'bytedance/seedance-2.5/reference-to-video',
]);

export const SEEDANCE_25_DRAFT_RESOLUTION = '480p';

export const SEEDANCE_25_AUTO_DURATION = 'auto';
export const SEEDANCE_25_DEFAULT_DURATION = '10';

/** Enhance renders a draft at 1080p, and costs what the draft's model costs at this resolution. */
export const SEEDANCE_25_ENHANCE_RESOLUTION = '1080p';

/**
 * Params an Enhance run sends for the draft result it finishes. Added to that one run's payload
 * only, never saved on the node. Keep in sync with `seedance-25-draft.consts.ts` in core.
 */
export const SEEDANCE_25_ENHANCE_ASSET_ID_PARAM = 'enhance_draft_asset_id';
export const SEEDANCE_25_ENHANCE_ASSET_URL_PARAM = 'enhance_draft_asset_url';
